import axios from '../utilities/axios'

async function getProcessors() {
  return axios.get('/api/v1/pop/processors')
}

export default {
  getProcessors,
}
